import React from "react";
import "../styles/Section1.scss";

const Section1 = () => {
  return (
    <section className="section-hero" id="sectionStart">
      {/* Video de fondo */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
      >
        <source src="https://capital24.mx/wp-content/uploads/2025/04/videoback.mp4" type="video/mp4" />
        Tu navegador no soporta el video.
      </video>

      {/* Capa oscura */}
      <div className="hero-overlay"></div>

      {/* Contenido */}
      <div className="hero-content">
        <h1>
          Resultados reales<br/><span className="highlight1">en tiempo record.</span>
        </h1>
        <p>
          Transformamos tu presencia digital en resultados reales: más clientes, más visibilidad y más ventas, con estrategias hechas a tu medida.
        </p>
        <a href="#inicio" className="hero-button">
          Invierte en tu crecimiento
        </a>
      </div>
    </section>
  );
};

export default Section1;
